import { PersistedState } from 'redux-persist/es/types'

export const migrations = {
  0: (state: PersistedState) => state,
}
